import { render } from "./BaseAddress.vue?vue&type=template&id=0945e19f"
import script from "./BaseAddress.js?vue&type=script&lang=js"
export * from "./BaseAddress.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__